export default __webpack_public_path__ + "static/media/17580.4d5f5fbe.jpg";